import * as React from "react";
import { CardProps } from "../types";
import styles from "./index.module.css";
import CheckMarkIcon from "../icons/CheckMarkIcon";
import InfoIcon from "../icons/InfoIcon";

function Card(props: CardProps) {
  function variantCss() {
    return props.variant ? " " + styles[props.variant] : "";
  }

  function flexCss() {
    return props.arrangement === "vertical" ? " " + styles["vertical"] : "";
  }

  function shouldDisplayIcon() {
    return typeof props.displayIcon === "boolean" ? props.displayIcon : true;
  }

  return (
    <article className={`${styles.container}${variantCss()}${flexCss()}`}>
      {props.title ? (
        <h3 className={styles.title}>
          {shouldDisplayIcon() ? (
            <>
              {props.variant === "success" ? (
                <CheckMarkIcon
                  svgAttrs={{
                    class: styles.svg,
                  }}
                />
              ) : null}
              {props.variant === "info" ? (
                <InfoIcon
                  svgAttrs={{
                    class: styles.svg,
                  }}
                />
              ) : null}
            </>
          ) : null}
          {props.title}
        </h3>
      ) : null}
      <div className={styles.body}>{props.children}</div>
    </article>
  );
}

export default Card;
